import { CAMPAIGN_INFO } from '@/pages/home/constants'

export default function abstractIsUserOnModelCity (userLocation, localUserLocation) {
  const dataUserLocation = userLocation || localUserLocation

  if (dataUserLocation) {
    return (
      CAMPAIGN_INFO.REGION_PATTERN.test(dataUserLocation.region)
      && CAMPAIGN_INFO.CITY_PATTERN.test(dataUserLocation.city)
    )
  }

  return false
}
